let config = {
  hotConfigUrl: '/json/externalConfig_backoffice.json',
  apiBaseUrl: 'https://cnp-api.clienteswebapp.com'
}

export default config
